(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    

class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"], input[name="currency_code"]'),
          button: this.querySelector('.localization-form__select'),
          spanText: this.querySelector('button .localization-name'),
          submitBtn: this.querySelector('.submit--btn'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          shippingTitle: this.querySelector('.js-shipping-title'),
          informationTitle: this.querySelector('.js-information-title'),
          shippingButton: this.querySelector('.js-shipping-button'),
        };

        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.submitBtn.addEventListener('click', this.onSubmitForm.bind(this));

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

        fetch('/browsing_context_suggestions.json')
          .then((response) => {
            return response.json();
          })
          .then((parsedState) => {
            const headerCountryLabel = document.querySelector('.header_localization .localization-item');
            const cartShippingInfoId = "js-cart-shipping-info";
            const currentCountry = parsedState.detected_values.country.handle;

            if( localStorage.getItem('dataLang') == null && localStorage.getItem('dataCountry') == null ){
              const countryName = parsedState.detected_values.country.name;

              localStorage.setItem('dataLang', currentCountry );
              localStorage.setItem('dataCountry', countryName );

              headerCountryLabel.innerText = currentCountry;
              this.elements.spanText.innerText = countryName;
              this.elements.input.value = currentCountry;
              this.renderDetailsList(currentCountry, this.capitalize(countryName));
              this.renderDetailsList(currentCountry, this.capitalize(countryName), cartShippingInfoId);
            } else {
              const countryCode = localStorage.getItem('dataLang');
              const countryName = localStorage.getItem('dataCountry');
              headerCountryLabel.innerText = countryCode;
              this.elements.spanText.innerText = countryName;
              this.elements.input.value = countryCode;
              this.renderDetailsList(countryCode, this.capitalize(countryName));
              this.renderDetailsList(countryCode, this.capitalize(countryName), cartShippingInfoId);
            }
          });

      }

      capitalize([first, ...rest], lowerRest = true) {
        return first.toUpperCase() + (lowerRest ? rest.join('').toLowerCase() : rest.join(''));
      }


      renderDetailsList(countryCode, countryName = "your country", listId = "js-info-list") {
        const defaultDetailsArray = [`Ships to ${countryName} (5-7 working days) from our warehouse`, "Free shipping & free returns", "VAT & Duties included"];

        const shipping_info_by_country = {
          US: {
            "shipping_title": "Shipping to",
            "information_title": "Information",
            "details":[
              "Ships to United States (5-9 working days) from our warehouse - USPS","Ships to United States (1-3 working days) from our warehouse - UPS express", "Free shipping & free returns", "VAT & Duties included"
            ],
            "button": "Save"
          },
          CA: {
            "shipping_title": "Shipping to",
            "information_title": "Information",
            "details":[
              "Ships to CANADA (5-9 working days) from our warehouse - Canada Post", "Ships to Canada (1-3 working days) from our warehouse - UPS express", "Free shipping & free returns", "VAT & Duties included (100 USD below) if shipped via Canada Post", "VAT & Duties excluded if shipped via UPS Express"
            ],
            "button": "Save"
          },
          UK: {
            "shipping_title": "Shipping to",
            "information_title": "Information",
            "details":[
              "Ships to the United Kingdom (5-7 working days) from our warehouse", "Free shipping & free returns", "VAT & Duties included"
            ],
            "button": "Save"
          },
          KR: {
            "shipping_title": "Shipping to",
            "information_title": "Information",
            "details":[
              "Ships to the South Korea (5-9 working days) from our warehouse", "Free shipping & free returns", "VAT & Duties included (150 USD below)"
            ],
            "button": "Save"
          },
          DE: {
            "shipping_title": "Versand nach",
            "information_title": "Informationen",
            "details":[
              "Versand nach Deutschland (5-7 Werktage) ab unserem Lager", "Kostenloser Versand und kostenloser Umtausch für alle Bestellungen", "Mehrwertsteuer und Zölle inbegriffen"
            ],
            "button": "Speichern"
          },
          SE: {
            "shipping_title": "Frakt till",
            "information_title": "Information",
            "details":[
              "Skickas från vårt lager i Norrköping, Sverige (1-2 dagars frakt)", "Gratis frakt & gratis utbyten på alla ordrar", "Moms inkluderat i priset"
            ],
            "button": "Spara"
          },
          FR: {
            "shipping_title": "Expédition à",
            "information_title": "Informations",
            "details":[
              "Expédié en France (5-7 jours ouvrés) depuis notre entrepôt", "Livraison gratuite et échanges gratuits sur toutes les commandes.", "TVA et droits inclus."
            ],
            "button": "Sauvegarder"
          },
          NO: {
            "shipping_title": "Frakt til",
            "information_title": "Informasjon",
            "details":[
              "Sendes til Norge (5-7 arbeidsdager) fra vårt lager.", "Gratis frakt og gratis bytte på alle bestillinger.", "MVA og avgifter inkludert (350 NOK under)."
            ],
            "button": "Spare"
          },
          CH: {
            "shipping_title": "Versand nach",
            "information_title": "Informationen",
            "details":[
              "Versand in die Schweiz (5-7 Werktage) ab unserem Lager.","Kostenloser Versand und kostenloser Umtausch bei allen Bestellungen.","MwSt. und Zölle inbegriffen."
            ],
            "button": "Speichere"
          },
          NL: {
            "shipping_title": "Verzending naar",
            "information_title": "Informatie",
            "details":[
              "Verzending naar Nederland (5-7 werkdagen) vanuit ons magazijn.", "Gratis verzending en gratis omruiling op alle bestellingen.", "BTW en invoerrechten inbegrepen.",
            ],
            "button": "Opslaan"
          },
          NZ: {
            "shipping_title": "Shipping to",
            "information_title": "Information",
            "details":[
              "Ships to New Zealand (5-9 working days) from our warehouse", "Free shipping & free returns", "VAT & Duties included"
            ],
            "button": "Save"
          },
          IL: {
            "shipping_title": "משלוח אל",
            "information_title": "מידע",
            "details":[
              "משלוח לישראל (5-7 ימי עסקים) ממחסננו.",
              "משלוח חינם והחלפה חינם על כל הזמנות." ,
              'כולל מע"מ ותשלומים.',
            ],
            "button": "לשמור"
          },
          ES: {
            "shipping_title": "Envío a:",
            "information_title": "Informatie",
            "details":[
              "Envíos a España (5-7 días laborables) desde nuestro almacén.","Envío gratuito y cambios gratuitos en todas las órdenes.","IVA e impuestos incluidos."
            ],
            "button": "Guardar"
          },
          IT: {
            "shipping_title": "Spedizione per:",
            "information_title": "Informazioni",
            "details":[
              "Spedizioni in Italia (5-7 giorni lavorativi) dal nostro magazzino.", "Spedizione gratuita e resi gratuiti su tutti gli ordini.", "IVA e dazi inclusi."
            ],
            "button": "Salva posizione"
          },
        }
        const list = document.getElementById(listId);
        list.replaceChildren();
        if(countryCode in shipping_info_by_country){
          this.elements.shippingTitle.innerText = shipping_info_by_country[countryCode].shipping_title
          this.elements.informationTitle.innerText = shipping_info_by_country[countryCode].information_title
          this.elements.shippingButton.innerText = shipping_info_by_country[countryCode].button

          shipping_info_by_country[countryCode].details.forEach((item) => {
              let li = document.createElement("li");
              li.innerText = item;
              list.appendChild(li);
          })
        } else {
          this.elements.shippingTitle.innerText = "Shipping to"
          this.elements.informationTitle.innerText = "Information"
          this.elements.shippingButton.innerText = "Save"

          defaultDetailsArray.forEach((item) => {
              let li = document.createElement("li");
              li.innerText = item;
              list.appendChild(li);
          })
        }
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();

        const countryCode = event.currentTarget.dataset.value;
        const countryName = event.currentTarget.innerText.trim();

        this.elements.input.value = countryCode;
        this.elements.spanText.innerText = countryName;

        // localStorage.setItem('dataCountry', countryCode);
        // localStorage.setItem('dataLang', countryCode);

        this.renderDetailsList(countryCode, this.capitalize(countryName))

        event.currentTarget.classList.add('disclosure__link--active');
        event.currentTarget.setAttribute('aria-current', 'true');

        this.hidePanel();
      }

      onSubmitForm(event){
        event.preventDefault();
        const form = this.querySelector('form');
        const formData = new FormData(form);
        const countryCode = formData.get('country_code');
        const countryName = this.elements.spanText.innerText;
        const cartShippingInfoId = "js-cart-shipping-info";
        const headerCountryLabel = document.querySelector('.header_localization .localization-item');

        // if (form) form.submit();
        //localStorage.setItem('dataLang', this.elements.input.value);

        localStorage.setItem('dataLang', countryCode);
        localStorage.setItem('dataCountry', countryName);

        headerCountryLabel.innerText = countryCode;
        this.renderDetailsList(countryCode, this.capitalize(countryName), cartShippingInfoId);

        MicroModal.close('lang-modal');
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        this.elements.spanText.innerText = localStorage.getItem('dataCountry');
        this.elements.input.value = localStorage.getItem('dataLang');
      }

      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
}

customElements.define('localization-form', LocalizationForm);

$(document).ready(function(){

    //     var localCountry;
    //     $('.country--selection select').on('change', function(){

    //         var id = $(this).data('id');
    //         var index = $(this).prop('selectedIndex');
    //         var localCountry = $(this).data('iso-code');

    //         $('.currency--selection select').prop('selectedIndex', index);
    //     });


    //     $('#countryCurrency').on('submit', function(e){
    //       e.preventDefault();

    //       var currency = $('select[name="currency_code"]').val();
    //       var locals =  $('.country--selection select').find(':selected').data('iso-code');
    //       console.log(locals);

    //       $('.currency-switcher').prop('selectedIndex', currency);
    //       $('.currency-switcher').trigger('change');
    //       $('.localization-item').text(locals);
    //       $('html').attr('lang', locals);
    //       sessionStorage.setItem('lang', locals);
    //       $('.modal__close').trigger('click');
    //     });



    //    if( typeof(Storage) !== "undefined" && sessionStorage.getItem('lang') ){
    //     var lang = sessionStorage.getItem('lang');
    //     $('.localization-item').text( sessionStorage.getItem('lang') );
    //     sessionStorage.setItem('lang', lang);
    //    } else {
    //     sessionStorage.setItem('lang', 'US');
    //    }


  // $.getJSON('/browsing_context_suggestions.json', function(data){
  //   var currentCountry = data.detected_values.country.handle;
  //   $('.header_localization .localization-item').text(currentCountry);
  // });

});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");

  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("summary").addEventListener("mouseenter", () => {
         item.setAttribute("open", true);
      });
     item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendationv2"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
